module.exports = __webpack_public_path__ + "img/without_image.9c433da0.png";